import React from 'react';
import ctaBanner from 'assets/images/cta-banner.png';
import withAnimation from 'HOCs/withAnimation';
import { sharedlinks } from 'shared-links';

const Cta = () => {
  return (
    <section className="p-4 my-10 md:my-32">
      <div className="w-full md:w-9/12 mx-auto">
        <a href={sharedlinks.waitlist} target="blank" rel="refererrer">
          <img
            src={ctaBanner}
            className="rounded-xl border-[3px] border-primary transition-all hover:scale-105"
          />
        </a>
      </div>
    </section>
  );
};

export default withAnimation(Cta);
